import { ChangeDetectionStrategy, Component, input, InputSignal, Optional, SkipSelf } from '@angular/core';
import { ControlContainer, ReactiveFormsModule } from '@angular/forms';
import { KeyValuePipe } from '@angular/common';

import { RadioComponent } from '../controllers/radio/radio.component';
import { CheckboxComponent } from '../controllers/checkbox/checkbox.component';
import { EditableRowComponent } from '../editable-row/editable-row.component';
import { DynamicValidationDependencies } from '../controllers/control-error/validation-error-messages.token';
import { WooCommercePaymentField } from '../../../core/interfaces/woo-commerce/api/payments/payments-api.interface';
import { WooCommercePaymentFieldType } from '../../../core/enums/woo-commerce/api/payments/payments-api.enum';
import {
  getPaymentFieldAutocomplete,
  getPaymentFieldMask
} from '../../utils/payment-field-mask.util';

@Component({
  selector: 'app-payment-fields',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    RadioComponent,
    CheckboxComponent,
    EditableRowComponent,
    KeyValuePipe,
    ...DynamicValidationDependencies
  ],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer | null) => container,
      deps: [[new Optional(), new SkipSelf(), ControlContainer]]
    }
  ],
  templateUrl: './payment-fields.component.html',
  styleUrl: './payment-fields.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentFieldsComponent {
  protected readonly WooCommercePaymentFieldType = WooCommercePaymentFieldType;
  protected readonly getPaymentFieldMask = getPaymentFieldMask;
  protected readonly getPaymentFieldAutocomplete = getPaymentFieldAutocomplete;

  fields: InputSignal<WooCommercePaymentField[]> = input.required<WooCommercePaymentField[]>();
}

